import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { isBrowser } from 'ws-scripts/modules/environment';

import Skeleton from 'wsm-skeleton';
import { setClassNames } from 'ddc-classnames-js';

const LazyCarousel = lazy(() =>
	import(
		/* webpackChunkName: 'new-media-focused-carousel' */ 'wsm-vehicle-media-gallery'
	).then((module) => ({
		default: module.MediaFocusedCarousel
	}))
);

const MediaFocusedCarouselContainer = ({
	shouldFullyRenderCard,
	images = []
}) => (
	<div
		className={setClassNames([
			'vehicle-card-media-container',
			!shouldFullyRenderCard && 'm-0'
		])}
	>
		{shouldFullyRenderCard && isBrowser ? (
			<Suspense fallback={<div>Loading...</div>}>
				<LazyCarousel images={images} />
			</Suspense>
		) : (
			<Skeleton
				skeletonClasses="mb-4"
				aspectRatio="4by3"
				dataTestId="media-skeleton"
			/>
		)}
	</div>
);

MediaFocusedCarouselContainer.propTypes = {
	shouldFullyRenderCard: PropTypes.bool,
	images: PropTypes.arrayOf(
		PropTypes.shape({
			alt: PropTypes.string,
			id: PropTypes.string,
			provider: PropTypes.string,
			title: PropTypes.string,
			uri: PropTypes.string
		})
	)
};

export default MediaFocusedCarouselContainer;
